<template>
  <Header expanded />
  <div
    class="pt-[50px] md:pt-0 grow flex flex-col pb-4 lg:pb-8"
    :class="{
      'sm:pt-[85px]': ['players-id'].includes(route.name?.toString()),
      'sm:pt-[80px]': !['players-id'].includes(route.name?.toString()),
    }"
  >
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
const route = useRoute();
</script>
